import React from "react";
import { useHistory } from "react-router-dom";
import { Card, Loader } from "@egovernments/digit-ui-react-components";
import { useTranslation } from "react-i18next";
import { FaFilePdf } from "react-icons/fa";
import SafeHtml from "@egovernments/digit-ui-module-common/src/sharedComponents/SafeHtml";

function ApplicationViewHistory({ id, formType }) {
  const { t } = useTranslation();
  const history = useHistory();
  const userInfo = Digit.UserService.getUser()?.info || {};
  const stateId = Digit.ULBService.getStateId();
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const isEmployee = history.location.pathname.includes("employee");
  const { data = {}, isLoading } = Digit.Hooks.obps.useBPADetailsPage(stateId, { applicationNo: id, isEmployee });
  const { applicationData, edcrDetails, collectionBillDetails } = data;

  let workflowDetails = Digit.Hooks.useWorkflowDetails({
    tenantId: tenantId,
    id: id,
    moduleCode: applicationData?.businessService,
  });

  const timelineStatusPrefix = `WF_${
    workflowDetails?.data?.applicationBusinessService ? workflowDetails?.data?.applicationBusinessService : applicationData?.businessService
  }_`;
  if (!isLoading && data && workflowDetails) {
    console.log("dfygbhusw", data, id, formType, workflowDetails);
  }
  console.log("yyyyyyyyyyy", userInfo);
  if (isLoading && data && workflowDetails) {
    return <Loader />;
  }

  return (
    <React.Fragment>
      {!isLoading && data && workflowDetails && (
        <React.Fragment>
          {workflowDetails?.data?.timeline?.length > 0 && (
            <React.Fragment>
              {workflowDetails?.data?.timeline?.map((item, index) => (
                <Card>
                  <b style={{ marginLeft: "2%" }}>
                    {t(`${timelineStatusPrefix}${item?.state}`)} by ({item?.assigner?.name})
                  </b>

                  {userInfo?.type === "EMPLOYEE" && (
                    <Card style={{ backgroundColor: "aliceblue", borderRadius: "20px" }}>
                      {item?.wfComment ? (
                        <div>
                          {item?.wfComment?.map((e) => (
                            <div className="TLComments" style={{ backgroundColor: "aliceblue" }}>
                              <h3>{t("WF_COMMON_COMMENTS")}</h3>
                              <i>{<SafeHtml html={e} />}</i>
                            </div>
                          ))}
                        </div>
                      ) : null}
                      {item?.wfComment ? (
                        <div>
                          {item?.wfComment?.map((e) => (
                            <div className="TLComments" style={{ backgroundColor: "aliceblue" }}>
                              <h3>Document</h3>
                              <div style={{ marginLeft: "10px" }}>
                                <a target="_" href={item?.wfDocuments?.[0]?.url} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                                  <p>
                                    <FaFilePdf color="#a10505" style={{ width: "20px", height: "30px" }} />
                                  </p>
                                </a>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : null}

                      <div style={{ textAlign: "end" }}>{item?.assigner?.name}</div>
                      <div style={{ textAlign: "end" }}>
                        {item?.assigner?.roles[0]?.code === ("EMPLOYEE" || "CITIZEN") && (
                          <React.Fragment>{item?.assigner?.roles[1]?.name}</React.Fragment>
                        )}
                        {item?.assigner?.roles[1]?.code === "EMPLOYEE" ||
                          ("CITIZEN" && <React.Fragment>{item?.assigner?.roles[0]?.name}</React.Fragment>)}
                      </div>
                      <div style={{ textAlign: "end" }}>{item?.assignes?.[0]?.mobileNumber}</div>
                      <div style={{ textAlign: "end" }}>{item?.auditDetails?.created}</div>
                    </Card>
                  )}
                  {userInfo?.type != "EMPLOYEE" && (
                    <div style={{ backgroundColor: "aliceblue", borderRadius: "20px", padding: "2%" }}>
                      {item?.wfComment ? (
                        <div>
                          {item?.wfComment?.map((e) => (
                            <div className="TLComments" style={{ backgroundColor: "aliceblue" }}>
                              <h3>{t("WF_COMMON_COMMENTS")}</h3>
                              <i>{<SafeHtml html={e} />}</i>
                            </div>
                          ))}
                        </div>
                      ) : null}
                      {item?.wfComment ? (
                        <div>
                          {item?.wfComment?.map((e) => (
                            <div className="TLComments" style={{ backgroundColor: "aliceblue" }}>
                              <h3>Document</h3>
                              <div style={{ marginLeft: "10px" }}>
                                <a target="_" href={item?.wfDocuments?.[0]?.url} style={{ minWidth: "80px", height: "auto", minWidth: "30px" }}>
                                  <p>
                                    <FaFilePdf color="#a10505" style={{ width: "20px", height: "30px" }} />
                                  </p>
                                </a>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : null}

                      <div style={{ textAlign: "end" }}>{item?.assigner?.name}</div>
                      <div style={{ textAlign: "end" }}>
                        {item?.assigner?.roles[0]?.code === ("EMPLOYEE" || "CITIZEN") && (
                          <React.Fragment>{item?.assigner?.roles[1]?.name}</React.Fragment>
                        )}
                        {item?.assigner?.roles[1]?.code === "EMPLOYEE" ||
                          ("CITIZEN" && <React.Fragment>{item?.assigner?.roles[0]?.name}</React.Fragment>)}
                      </div>
                      <div style={{ textAlign: "end" }}>{item?.assignes?.[0]?.mobileNumber}</div>
                      <div style={{ textAlign: "end" }}>{item?.auditDetails?.created}</div>
                    </div>
                  )}
                </Card>
              ))}
              <br />
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export default ApplicationViewHistory;
